import React, { Component, ChangeEvent } from "react";
import {
    Nav, NavItem, NavLink, TabContent, TabPane
} from "reactstrap";
import * as KSLPlusAPI from "../services/KSLPlusAPI"


import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
// @ts-ignores
import BootstrapTable from 'react-bootstrap-table-next';
// @ts-ignore
import cellEditFactory from 'react-bootstrap-table2-editor';
// @ts-ignore
import paginationFactory from 'react-bootstrap-table2-paginator';

import * as Utilities from "./Utilities"

import { HaushaltsDetailiertVgl } from './HaushaltsDetailiertVglComp';
import { ImgButton } from './ImgButtonComp';

import '../custom.css';
import { ENGINE_METHOD_PKEY_ASN1_METHS } from "constants";

import { VBTab } from './VBTabComp';

import * as QueryString from "query-string";

type State = {
    ready: boolean;        
    activeMainTab: string,
    selectedGLEbene: string;    
    isVisible: boolean;
    plantyp1: number;
    planstufe1: number;
    plantyp2: number;
    planstufe2: number;
    psBasisValue: string;
    psVglValue: string;
}

type Props = {    
    kunde: number,
    gemeinde: number,
    jahr: number,
    plantyp: number,
    planstufe: number,
    verwaltungsansicht: boolean,
    psVgl: KSLPlusAPI.Planstufen[],    
    settings: KSLPlusAPI.SettingsModel,
    isVisible: boolean,
    query: string | undefined
}



export class PlanvergleichDoppisch extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        
            

    }

    node: any;
    
    
    state: State = {
        ready: true,        
        activeMainTab: "1",
        selectedGLEbene: "",
        isVisible: false,
        plantyp1: 0,
        planstufe1: 0,
        plantyp2: 0,
        planstufe2: 0,
        psBasisValue: "",
        psVglValue: ""
    }    

    handleSelectHHEbene = (ebenenNum: string) => {                
        this.setState({selectedGLEbene: ebenenNum} );        
    } 

    initPS = () => {
        var ps = this.props.psVgl.find(ps => ps.planstufe === this.props.planstufe && ps.plantyp === this.props.plantyp);
        if (!ps && this.props.psVgl.length > 0) {
            ps = this.props.psVgl[0];
        }
        var ps1 = 0;
        var pt1 = 0;
        if (ps) {
            ps1 = ps.planstufe??0;
            pt1 = ps.plantyp??0;
            this.setState({ planstufe2: ps.planstufe ?? 0, plantyp2: ps.plantyp ?? 0, psVglValue: ps.datum ? ps.datum.toUTCString() : "" });
        }
        ps = this.props.psVgl.concat([]).reverse().find(ps => ps.planstufe !== ps1 || ps.plantyp !== pt1);
        if (ps) {
            this.setState({ planstufe1: ps.planstufe ?? 0, plantyp1: ps.plantyp ?? 0, psBasisValue: ps.datum ? ps.datum.toUTCString() : "" });
            
        }
    }


    componentDidUpdate(prevProps: Props) {
        if (prevProps.isVisible !== this.props.isVisible && this.props.isVisible !== this.state.isVisible) {
            this.setState({ activeMainTab: "1" });       
            this.parseParams();
        }
        if (prevProps.plantyp !== this.props.plantyp)
            this.initPS();
        if (prevProps.planstufe !== this.props.planstufe)
            this.initPS();
        
    }

    
    componentDidMount() {     
        this.initPS();     
        this.parseParams();
    }

    parseParams = () => {
        if (!this.props.query)
            return;

        const params = QueryString.parse(this.props.query);


        if (params.pvt != null) {
            if (Array.isArray(params.pvt))
                this.setState({ activeMainTab: params.pvt[0] });
            else
                this.setState({ activeMainTab: params.pvt });
        }
    }

    createPSBasisOptions = () => {

        var items: JSX.Element[] = [];
        this.props.psVgl.forEach((ps) => {               
            items.push(<option disabled={ps.planstufe === this.state.planstufe2 && ps.plantyp === this.state.plantyp2}  value={ps.datum ? ps.datum.toUTCString() : ""}>{ps.bezeichnung}</option>);
        });
        
        return items;
    }

    handlePSBasisChange(event: ChangeEvent<HTMLSelectElement>) {
        if (event.target != null) {
            var ps = this.props.psVgl.find(ps => ps.datum && ps.datum.toUTCString() === event.target.value);

            if ( ps )
                this.setState({ planstufe1: ps.planstufe??0, plantyp1: ps.plantyp??0, psBasisValue: ps.datum ? ps.datum.toUTCString() : "" })
        }
    }

    


    createPSVglOptions = () => {

        var items: JSX.Element[] = [];
        this.props.psVgl.forEach((ps) => {            
            items.push(<option disabled={ps.planstufe === this.state.planstufe1 && ps.plantyp === this.state.plantyp1} value={ps.datum ? ps.datum.toUTCString() : ""}>{ps.bezeichnung}</option>);
        });

        return items;
    }

    handlePSVglChange(event: ChangeEvent<HTMLSelectElement>) {
        if (event.target != null) {
            var ps = this.props.psVgl.find(ps => ps.datum && ps.datum.toUTCString() === event.target.value);

            if (ps)
                this.setState({ planstufe2: ps.planstufe ?? 0, plantyp2: ps.plantyp ?? 0, psVglValue: ps.datum ? ps.datum.toUTCString() : "" })
        }
    }

    switchBasisAndVg = () => {
        var planstufe1 = this.state.planstufe1;
        var planstyp1 = this.state.plantyp1;
        var psVal = this.state.psBasisValue;
        this.setState({planstufe1: this.state.planstufe2, plantyp1: this.state.plantyp2, psBasisValue: this.state.psVglValue, planstufe2: planstufe1, plantyp2: planstyp1, psVglValue: psVal})
    }

    render() {
        if (this.state.plantyp2 === 0) {
            this.initPS();
            return null;
        }
                        
        return (
            <div className="kslplus-haushaltstab-wrapper-middle">  
                <div className="kslplus-uhconfig-wrapper">
                    <label >Basisplanstufe:</label>
                    <select className="kslplus-select form-select" value={this.state.psBasisValue} onChange={(e) => this.handlePSBasisChange(e)} >
                        {this.createPSBasisOptions()}
                    </select>
                    <ImgButton tttext="Tauschen" id="kslplus-switch-ps" className="kslplus-button" type="switch" onClick={() => this.switchBasisAndVg()} />                    
                    <label >Vergleichsplanstufe:</label>
                    <select className="kslplus-select form-select" value={this.state.psVglValue} onChange={(e) => this.handlePSVglChange(e)} >
                        {this.createPSVglOptions()}
                    </select>
                </div>
                <Nav tabs>                                    
                    <NavItem id="kslplus-tab-verwaltungshaushalt-detailliert">
                        <NavLink active={this.state.activeMainTab === "1"} onClick={() => this.setState({ activeMainTab: "1" })} tabIndex={0} onKeyDown={(e) => { if (e.keyCode === 13) this.setState({ activeMainTab: "1" }); }}>
                            <div className="kslplus-reiter-text-hauptzeile">Ergebnishaushalt</div>
                        </NavLink>                        
                    </NavItem>                    
                    <NavItem id="kslplus-tab-vermögenshaushalt-detailliert">
                        <NavLink active={this.state.activeMainTab === "2"} onClick={() => this.setState({ activeMainTab: "2" })} tabIndex={0} onKeyDown={(e) => { if (e.keyCode === 13) this.setState({ activeMainTab: "2" }); }}>
                            <div className="kslplus-reiter-text-hauptzeile">Finanzhaushalt</div>
                                                
                        </NavLink>
                    </NavItem>                                            
                </Nav>
                
                <TabContent activeTab={this.state.activeMainTab}>                    
                                                                
                    <TabPane tabId="1">

                        <HaushaltsDetailiertVgl kunde={this.props.kunde} gemeinde={this.props.gemeinde} jahr={this.props.jahr} plantyp={this.state.plantyp1} planstufe={this.state.planstufe1} plantypvgl={this.state.plantyp2} planstufevgl={this.state.planstufe2} settings={this.props.settings} isVisible={this.props.isVisible && this.state.activeMainTab === "1"} summenTyp={this.props.plantyp == 3 ? 9 : (this.props.plantyp == 4 ? 19 : 3)} verwaltungsansicht={this.props.verwaltungsansicht} query={this.props.query} />
                                        
                    </TabPane>
                    <TabPane tabId="2">
                        <HaushaltsDetailiertVgl kunde={this.props.kunde} gemeinde={this.props.gemeinde} jahr={this.props.jahr} plantyp={this.state.plantyp1} planstufe={this.state.planstufe1} plantypvgl={this.state.plantyp2} planstufevgl={this.state.planstufe2} settings={this.props.settings} isVisible={this.props.isVisible && this.state.activeMainTab === "2"} summenTyp={this.props.plantyp == 3 ? 10 : (this.props.plantyp == 4 ? 20 : 4)} verwaltungsansicht={this.props.verwaltungsansicht} query={this.props.query} />
                            
                    </TabPane>                                       
                </TabContent>
                               
            </div>
        );
    }
}